import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Alert,
  Spinner,
  Progress
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useParams } from 'react-router-dom';

const FormEditVideos = () => {
  document.title = "Edit Videos | Uma Classes";
  const { id } = useParams();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    categoryId: "",
    subcategoryId: "",
    subSubcategoryId: "",
    videoUrl: "",
  });

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [subSubcategories, setSubSubcategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false); // Track upload state
  const [progress, setProgress] = useState(0); // Progress state for progress bar

  useEffect(() => {
    const fetchCategoriesAndVideo = async () => {
      try {
        const token = localStorage.getItem('token');

        // Fetch categories
        const categoriesResponse = await axios.get('https://uma.aasmo.in/api/admin/getall-category', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCategories(categoriesResponse);

        // Fetch subcategories
        const subcategoriesResponse = await axios.get('https://uma.aasmo.in/api/admin/getall-subcategory', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSubcategories(subcategoriesResponse);

        // Fetch sub-subcategories
        const subSubcategoriesResponse = await axios.get('https://uma.aasmo.in/api/admin/getall-subsubcategory', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSubSubcategories(subSubcategoriesResponse);

        // Fetch Video details
        const videoResponse = await axios.get(`https://uma.aasmo.in/api/admin/getbyid-video/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Set Video data to form state
        const videoData = videoResponse; // Correctly access video data
        setFormData({
          title: videoData.title,
          description: videoData.description,
          categoryId: videoData.category._id, // Set category ID
          subcategoryId: videoData.subcategory._id, // Set subcategory ID
          subSubcategoryId: videoData.subSubcategory._id, // Set sub-subcategory ID
          videoUrl: videoData.videoUrl, // Set the existing video URL
        });

        setLoading(false);
      } catch (error) {
        console.error("Error fetching categories or Video details:", error);
        setLoading(false);
      }
    };

    fetchCategoriesAndVideo();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (e.target.files) {
      setFile(e.target.files[0]); // Handle file input
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');

      const formDataToSend = new FormData();
      formDataToSend.append('title', formData.title);
      formDataToSend.append('description', formData.description);
      formDataToSend.append('categoryId', formData.categoryId);
      formDataToSend.append('subcategory', formData.subcategoryId);
      formDataToSend.append('subSubcategory', formData.subSubcategoryId);
      formDataToSend.append('videoUrl', formData.videoUrl);
      // if (file) {
      //   formDataToSend.append('video', videoUrl); // New file if uploaded
      // } else {
      //   formDataToSend.append('video', formData.video); // Existing video URL
      // }

      setUploading(true);
      setProgress(0); // Reset progress bar on submission

      // Upload video with progress tracking
      await axios.put(`https://uma.aasmo.in/api/admin/update-video/${id}`, formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgress(percent); // Update progress bar
        },
      });

      setUploading(false);
      setSuccessMessage("Video Edited successfully");
      setErrorMessage("");
    } catch (error) {
      console.error("Error Editing Video:", error);
      setUploading(false);
      setSuccessMessage("");
      setErrorMessage("Error Editing Video");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Videos" breadcrumbItem="Edit" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>

                    <Row className="mb-3">
                      <label htmlFor="title" className="col-md-2 col-form-label">Title</label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="title"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          placeholder="Enter Title"
                          required
                        />
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="description" className="col-md-2 col-form-label">Description</label>
                      <div className="col-md-12">
                        <textarea
                          className="form-control"
                          id="description"
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          placeholder="Enter Description"
                          required
                        />
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="categoryId" className="col-md-2 col-form-label">Category</label>
                      <div className="col-md-12">
                        <select
                          className="form-control"
                          id="categoryId"
                          name="categoryId"
                          value={formData.categoryId}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Category</option>
                          {categories.map(category => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="subcategoryId" className="col-md-2 col-form-label">Subcategory</label>
                      <div className="col-md-12">
                        <select
                          className="form-control"
                          id="subcategoryId"
                          name="subcategoryId"
                          value={formData.subcategoryId}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Subcategory</option>
                          {subcategories.map(subcategory => (
                            <option key={subcategory._id} value={subcategory._id}>
                              {subcategory.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>

                    <Row className="mb-3">
                      <label htmlFor="subSubcategoryId" className="col-md-2 col-form-label">Sub-Subcategory</label>
                      <div className="col-md-12">
                        <select
                          className="form-control"
                          id="subSubcategoryId"
                          name="subSubcategoryId"
                          value={formData.subSubcategoryId}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Sub-Subcategory</option>
                          {subSubcategories.map(subSubcategory => (
                            <option key={subSubcategory._id} value={subSubcategory._id}>
                              {subSubcategory.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>

                    {/* <Row className="mb-3">
                      <label htmlFor="video" className="col-md-2 col-form-label">Video URL</label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="video"
                          name="video"
                          value={formData.video}
                          onChange={handleChange}
                          placeholder="Enter Video URL"
                          required
                        />
                      </div>
                    </Row> */}
                    <Row className="mb-3">
                      <label htmlFor="videoUrl" className="col-md-2 col-form-label">
                        Video URL
                      </label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="text"
                          id="videoUrl" // Ensure the ID is 'videoUrl'
                          name="videoUrl" // Ensure the name is 'videoUrl'
                          value={formData.videoUrl}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </Row>
                    {/* <Row className="mb-3">
                      <label htmlFor="file" className="col-md-2 col-form-label">Upload New Video (Optional)</label>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          type="file"
                          id="file"
                          name="file"
                          onChange={handleChange}
                        />
                      </div>
                    </Row> */}

                    <div className="d-flex justify-content-end">
                      <button type="submit" className="btn btn-primary" disabled={uploading}>
                        {uploading ? <Spinner size="sm" /> : 'Save'}
                      </button>
                    </div>
                  </form>

                  {uploading && (
                    <div className="mt-3">
                      <Progress value={progress} />
                      <p>{progress}%</p>
                    </div>
                  )}

                  {successMessage && <Alert color="success">{successMessage}</Alert>}
                  {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormEditVideos;
